import appStrings from '@/app/utility/string.utility';
export default {
  name: 'Specification',
  props: {
    parentProjectUnitData: Object
  },
  data() {
    return {
      unsubscribe: null,
      unitCategoryId: null,
      parent_value_set_id: null,
      showModalComponent: false,
      showValueSetModal: false,
      editMode: false,
      loader: false,
      showAlert: false,
      isSuccess: false,
      responseMsg: '',
      unitId: null,
      widthType: null,

      carParkOpenExc: null,
      carParkOpenNonExc: null,
      carParkCoverExc: null,
      carParkCoverNonExc: null,
      unitCategory: {
        value: null,
        text: null
      },
      unitSubcategory: {
        value: null,
        text: null
      }
    };
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save' && this.editMode == true) {
          this.addEditProjectUnitSpec();
        }
        if (actionName === 'update') {
          this.editMode = true;
        }
      }
    });
    this.unitId = this.parentProjectUnitData.project_unit_id;
    this.getProjectUnitSpec();
  },
  methods: {
    getProjectUnitSpec() {
      const payload = {
        prjUnitId: this.unitId
      };
      this.loader = true;
      this.$store
        .dispatch('projects/getProjectUnitSpec', payload)
        .then(response => {
          this.loader = false;
          const results = response.data.data;
          this.unitId = results.project_unit_id;
          this.projectUnitSpecId = results.project_unit_specification_id;
          this.carParkOpenExc = results.car_park_open_executive;
          this.carParkOpenNonExc = results.car_park_open_nonexecutive;
          this.carParkCoverExc = results.car_park_cover_executive;
          this.unitCategory = {
            value: results.unit_category_vset,
            text: results.unit_category_meaning
          };
          this.carParkCoverNonExc = results.car_park_cover_nonexecutive;
          this.unitSubcategory = {
            value: results.unit_sub_category_vset,
            text: results.unit_sub_category_meaning
          };
        })
        .catch(() => {
          this.loader = false;
        });
    },
    addEditProjectUnitSpec() {
      const payload = {
        car_park_open_executive: this.carParkOpenExc,
        unit_sub_category_vset: this.unitSubcategory.value,
        car_park_open_nonexecutive: this.carParkOpenNonExc,
        unit_category_vset: this.unitCategory.value,
        project_unit_id: this.unitId,
        car_park_cover_nonexecutive: this.carParkCoverNonExc,
        car_park_cover_executive: this.carParkCoverExc,
        project_unit_specification_id: this.projectUnitSpecId
      };
      this.loader = true;
      this.$store
        .dispatch('projects/addEditProjectUnitSpec', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.editMode = false;
            this.showAlert = true;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
            const results = response.data.data;
            this.projectUnitSpecId = results.project_unit_specification_id;
          } else {
            this.showAlert = true;
            this.isSuccess = false;
            this.responseMsg = response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
          this.showAlert = true;
          this.isSuccess = false;
          this.responseMsg = appStrings.autoFailedMsg;
        });
    },
    selectedvalueSet(item) {
      if (this.vsetCode === 'UNIT_CAT') {
        this.unitCategory = {
          value: item.value_code,
          text: item.value_meaning
        };
        this.unitCategoryId = item.value_set_dtl_id;
      } else if (this.vsetCode === appStrings.VALUESETTYPE.UNIT_SUB_CAT) {
        this.unitSubcategory = {
          value: item.value_code,
          text: item.value_meaning
        };
      }
    },
    openValueSetModal(vsetCode, widthType) {
      if (vsetCode === appStrings.VALUESETTYPE.UNIT_SUB_CAT) {
        this.parent_value_set_id = this.unitCategoryId;
      } else {
        this.parent_value_set_id = null;
      }
      this.vsetCode = vsetCode;
      this.widthType = widthType;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    clearVsetValues(vsetCode){
      if (vsetCode === 'UNIT_CAT') {
        this.unitCategory = {
          value: null,
          text: null
        };
        this.unitCategoryId = null;
      } else if (vsetCode === appStrings.VALUESETTYPE.UNIT_SUB_CAT) {
        this.unitSubcategory = {
          value: null,
          text: null
        };
      }
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
